import { render, staticRenderFns } from "./SalarySurveyTable.vue?vue&type=template&id=a6d3566a"
import script from "./SalarySurveyTable.vue?vue&type=script&lang=js"
export * from "./SalarySurveyTable.vue?vue&type=script&lang=js"
import style0 from "./SalarySurveyTable.vue?vue&type=style&index=0&id=a6d3566a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports